import type { FaireProductEntity } from "../../entity_types/product";

export const p_nue5mt5rh2: FaireProductEntity = {
  token: "p_nue5mt5rh2",
  type: "product",
  name: "Wool Striped Triangle Scarf",
  brandToken: "b_aerqrduuww",
  brandName: "MoodGold",
  imageUrl:
    "https://cdn.faire.com/fastly/f50fcfd415f354cfb4dbbc6628236cc207edadd74f457361df83b75ee51b3fd6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3099b947fbac6ecf81e7fb0007a68219d2e962c6b199fcbdcf94582dcdf76c2b.jpeg",
    "https://cdn.faire.com/fastly/41cdedff181802f4df940b273fc92d56b1a6f656b1eaefc3458ccdd4e041f76f.jpeg",
    "https://cdn.faire.com/fastly/574ce3c6c6dbc10f921822e8682d3bb9510ba9c418245da9880d566a40098c31.jpeg",
    "https://cdn.faire.com/fastly/1ceb428425498ca50245ee5d76f8e9b6f3d5f336e92aaa4b74f73b1480b78284.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Material:Wool Blend\n\nStyle:Cute,Intellectual,All-match,Look-younger\n\nOccasion:Business,Gift,Going out,Artistic Retro,Girlish Sweetness,Light Maturity,Stylish Selection,Leisure Fashion\n\nSeasons:Spring,Autumn,Winter\n",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:47.603Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
